/* ==================================================================
   GB — Collection List Banner: desktop mouse grab-to-scroll.
   Count-driven, page-agnostic (no /all dependency): binds to this
   section's sliders on any collection page and is inert on static
   grids (scrollWidth check in pointerdown), so it complements the
   arrows wherever the carousel engages. Mouse-only (pointerType
   check): touch and pen keep the native scroll they already have.
   While dragging, .slider--gb-grabbing suspends Dawn's scroll snap +
   smooth behavior (rules live in section-collection-list-banner.css);
   on release the class lifts and the browser snaps to the nearest
   card — the same landing Dawn's thumb-scroll gives. The click that
   follows a drag release is swallowed so letting go over a card never
   navigates. Scoped to .collection-list-banner: no other section's
   carousel is affected, and Dawn's SliderComponent (global.js) is
   untouched — its scroll listener keeps the counter in sync during
   the drag.
   ================================================================== */
(function () {
  var GRABBING_CLASS = 'slider--gb-grabbing';
  var DRAG_THRESHOLD = 6; // px of travel before a press becomes a drag

  function bindGrab(slider) {
    if (!slider || slider.dataset.gbGrabBound === 'true') return;
    slider.dataset.gbGrabBound = 'true';

    var pointerId = null;
    var dragging = false;
    var startX = 0;
    var startScrollLeft = 0;
    var suppressClick = false;

    slider.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (slider.scrollWidth <= slider.clientWidth) return;
      pointerId = event.pointerId;
      dragging = false;
      startX = event.clientX;
      startScrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('pointermove', function (event) {
      if (pointerId === null || event.pointerId !== pointerId) return;
      var delta = event.clientX - startX;
      if (!dragging) {
        if (Math.abs(delta) < DRAG_THRESHOLD) return;
        dragging = true;
        slider.classList.add(GRABBING_CLASS);
        try {
          slider.setPointerCapture(pointerId);
        } catch (error) {
          // Pointer already gone (e.g. released mid-frame) — drag still works.
        }
      }
      event.preventDefault();
      slider.scrollLeft = startScrollLeft - delta;
    });

    function release(event) {
      if (pointerId === null || event.pointerId !== pointerId) return;
      if (dragging) {
        suppressClick = true;
        slider.classList.remove(GRABBING_CLASS); // snap re-engages → nearest card
        try {
          slider.releasePointerCapture(pointerId);
        } catch (error) {
          // Capture already released — nothing to undo.
        }
        // If no click follows (released between cards), clear the flag.
        setTimeout(function () {
          suppressClick = false;
        }, 0);
      }
      pointerId = null;
      dragging = false;
    }

    slider.addEventListener('pointerup', release);
    slider.addEventListener('pointercancel', release);

    // Native link/image drag would hijack the grab mid-press.
    slider.addEventListener('dragstart', function (event) {
      if (pointerId !== null || dragging) event.preventDefault();
    });

    // Swallow the click that immediately follows a drag release.
    slider.addEventListener(
      'click',
      function (event) {
        if (suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          suppressClick = false;
        }
      },
      true
    );
  }

  function init() {
    document
      .querySelectorAll('.collection-list-banner slider-component .slider')
      .forEach(bindGrab);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: rebind after the section re-renders.
  document.addEventListener('shopify:section:load', init);
})();
